import { Maybe } from "@/domains/common/types";
import { AppStore } from "@/store/AppStore";
import { SessionKind, SessionModelData, SessionStatus } from "@/store/sessions/types";
import { OptimisticSyncUpdate, SyncUpdateValue } from "@/store/sync/types";

export type SessionIndexData = {
  kind: SessionKind;
  status: SessionStatus;
  created_at: string;
  last_user_action_at: string;
  title: string;
};

export class SessionIndexes {
  private store: AppStore;
  private data: SyncUpdateValue<SessionModelData>;

  constructor({
    store,
    remoteData,
    optimisticUpdates,
  }: {
    store: AppStore;
    remoteData: Maybe<SyncUpdateValue<SessionModelData>>;
    optimisticUpdates: OptimisticSyncUpdate<SessionModelData>[];
  }) {
    this.store = store;
    this.data =
      (optimisticUpdates.at(-1)?.value as SyncUpdateValue<SessionModelData>) || remoteData;
  }

  get kind(): SessionKind {
    return this.data.model_data.kind as SessionKind;
  }

  get status(): SessionStatus {
    return this.data.model_data.status as SessionStatus;
  }

  get created_at(): string {
    return this.data.model_data.created_at;
  }

  get lastUserActionAt(): string {
    return this.data.model_data.last_user_action_at || "";
  }

  get title(): string {
    return this.data.model_data.title || "";
  }

  get indexes(): SessionIndexData {
    return {
      kind: this.kind,
      status: this.status,
      created_at: this.created_at,
      last_user_action_at: this.lastUserActionAt,
      title: this.title,
    };
  }
}
